import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=378226b7&scoped=true&lang=pug"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378226b7",
  null
  
)

export default component.exports